var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDigitalOutOfHome = function SvgDigitalOutOfHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#E9F1FF",
    rx: 4
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 12,
    height: 12,
    x: 4,
    y: 4,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M4 4h12v12H4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#92B7FF",
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 15.5v-10q0-.412.294-.706A.96.96 0 0 1 5.75 4.5h3.5q.412 0 .706.294a.96.96 0 0 1 .294.706v10h-1v-1h-3.5v1zm2-5 1.75-1-1.75-1zM11.25 15.5V8.227a.7.7 0 0 1 .214-.513.7.7 0 0 1 .513-.214h2.546a.7.7 0 0 1 .513.214.7.7 0 0 1 .214.513V15.5h-.727v-.727h-2.546v.727zm1.454-3.636 1.273-.728-1.273-.727z"
  }))));
};
export default SvgDigitalOutOfHome;